var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUsability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "1 -66 511.99937 511",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 174.260278799,
    x2: 379.9455248264,
    y1: 215.9686814364,
    y2: 444.690524029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0633,
    stopColor: "#37355a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#232543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#171b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 516.1689057128,
    x2: 453.2188802326,
    xlinkHref: "#b",
    y1: 363.9273081496,
    y2: 300.9771822772
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 240.0330317666,
    x2: 240.0330317666,
    xlinkHref: "#b",
    y1: 342.8177398634,
    y2: 396.8252297364
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 507.3579842798,
    x2: 436.740705309,
    xlinkHref: "#b",
    y1: 413.3935568556,
    y2: 342.7761774926
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 346.2420562268,
    x2: 442.378731261,
    xlinkHref: "#f",
    y1: 252.2775284104,
    y2: 348.4143038368
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0343,
    stopColor: "#9fb3d5",
    stopOpacity: 0.035294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4515,
    stopColor: "#8898af",
    stopOpacity: 0.45098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#798898",
    stopOpacity: 0.788235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 459.5831433594,
    x2: 406.5702390118,
    xlinkHref: "#h",
    y1: 341.8948343688,
    y2: 288.8819300212
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#05e5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    stopColor: "#13ddac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    stopColor: "#2ad1a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac9a0"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 420.6328772112,
    x2: 420.6328772112,
    xlinkHref: "#j",
    y1: 248.2835251256,
    y2: 346.307673912
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 174.260278799,
    x2: 379.9455248264,
    y1: 18.5579613174,
    y2: 247.27980391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3262,
    stopColor: "#fe4672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#fb3e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    stopColor: "#f52f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#ee1a51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4003d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5838,
    stopColor: "#bd294b",
    stopOpacity: 0.584314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 516.1689057128,
    x2: 453.2188802326,
    xlinkHref: "#m",
    y1: 166.5165880306,
    y2: 103.5665625504
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 240.0330317666,
    x2: 240.0330317666,
    xlinkHref: "#m",
    y1: 145.4071201366,
    y2: 199.4145096174
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 452.1635574262,
    x2: 379.213966865,
    xlinkHref: "#m",
    y1: 160.7883094908,
    y2: 87.8387189296
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 346.2420562268,
    x2: 442.378731261,
    xlinkHref: "#f",
    y1: 54.8669086836,
    y2: 151.0035837178
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#ffbb23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 44.0588236374,
    x2: 225.1598269444,
    xlinkHref: "#r",
    y1: 52.178104391,
    y2: 52.178104391
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 44.0588236374,
    x2: 225.1598269444,
    xlinkHref: "#r",
    y1: 91.6971927444,
    y2: 91.6971927444
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 44.0588236374,
    x2: 188.2691067792,
    xlinkHref: "#r",
    y1: 131.21638149,
    y2: 131.21638149
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 459.5831433594,
    x2: 406.5702390118,
    xlinkHref: "#h",
    y1: 144.4841142498,
    y2: 91.4712099022
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 420.6328772112,
    x2: 420.6328772112,
    xlinkHref: "#j",
    y1: 50.8729053988,
    y2: 148.896953793
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m451.066406 380.304688h-422.066406c-16.015625 0-29-12.980469-29-29v-124.394532c0-16.015625 12.984375-29 29-29h422.066406c16.015625 0 29 12.984375 29 29v124.394532c0 16.019531-12.984375 29-29 29zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m480.066406 351.304688v-124.394532c0-2.097656-.226562-4.140625-.652344-6.113281l-77.984374 77.976563c-3.945313 3.957031-10.402344 3.957031-14.371094 0l-32.191406-32.195313c-5.855469-5.859375-15.355469-5.859375-21.210938 0-5.851562 5.863281-5.851562 15.359375 0 21.210937l92.515625 92.515626h24.894531c16.015625 0 29-12.980469 29-29zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 289.109375v62.199219c0 16.015625 12.984375 28.996094 29 28.996094h422.066406c16.015625 0 29-12.980469 29-28.996094v-62.199219zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m476.566406 365.128906c.445313-.820312.851563-1.667968 1.21875-2.535156.183594-.433594.359375-.871094.519532-1.316406.324218-.890625.609374-1.796875.847656-2.722656.238281-.929688.429687-1.871094.578125-2.832032.21875-1.441406.335937-2.914062.335937-4.417968v-80.4375l-38.046875-38.042969c-2.535156-3.339844-6.539062-5.503907-11.058593-5.503907h-95.78125c-7.675782 0-13.898438 6.222657-13.898438 13.898438v95.78125c0 4.515625 2.167969 8.519531 5.507812 11.054688l32.246094 32.25h92.03125c5.503906 0 10.652344-1.535157 15.035156-4.199219.796876-.484375 1.570313-1.003907 2.316407-1.5625.371093-.277344.734375-.5625 1.09375-.859375.714843-.589844 1.402343-1.214844 2.058593-1.871094 1.96875-1.96875 3.65625-4.21875 4.996094-6.683594zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m430.964844 350.894531h-95.785156c-7.671876 0-13.894532-6.21875-13.894532-13.894531v-95.78125c0-7.675781 6.222656-13.898438 13.894532-13.898438h95.785156c7.671875 0 13.894531 6.222657 13.894531 13.898438v95.78125c0 7.675781-6.222656 13.894531-13.894531 13.894531zm0 0",
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a1b5d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.058594 241.59375h181.101562v15.992188h-181.101562zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.058594 281.113281h181.101562v15.992188h-181.101562zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.058594 320.628906h144.210937v15.992188h-144.210937zm0 0"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m430.964844 350.894531c7.671875 0 13.894531-6.21875 13.894531-13.894531v-81.648438l-43.429687 43.425782c-3.945313 3.957031-10.402344 3.957031-14.371094 0l-32.191406-32.195313c-5.855469-5.859375-15.355469-5.859375-21.210938 0-5.851562 5.859375-5.851562 15.355469 0 21.207031l63.105469 63.105469zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m507.605469 213.828125c5.859375 5.855469 5.859375 15.351563 0 21.210937l-84.960938 84.949219c-15.660156 15.660157-41.140625 15.660157-56.792969 0l-32.195312-32.195312c-5.855469-5.855469-5.855469-15.351563 0-21.207031 5.855469-5.863282 15.351562-5.863282 21.210938-.003907l32.191406 32.191407c3.960937 3.960937 10.417968 3.960937 14.371094 0l84.960937-84.953126c5.855469-5.855468 15.351563-5.855468 21.210937 0zm0 0",
    fill: "url(#k)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m451.066406 182.894531h-422.066406c-16.015625 0-29-12.984375-29-29v-124.394531c0-16.015625 12.984375-29 29-29h422.066406c16.015625 0 29 12.984375 29 29v124.394531c0 16.015625-12.984375 29-29 29zm0 0",
    fill: "url(#l)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m480.066406 153.894531v-124.394531c0-2.097656-.226562-4.140625-.652344-6.113281l-77.984374 77.976562c-3.945313 3.957031-10.402344 3.957031-14.371094 0l-32.191406-32.191406c-5.855469-5.863281-15.355469-5.863281-21.210938 0-5.851562 5.859375-5.851562 15.355469 0 21.207031l92.515625 92.515625h24.894531c16.015625 0 29-12.984375 29-29zm0 0",
    fill: "url(#n)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m0 91.695312v62.199219c0 16.015625 12.984375 29 29 29h422.066406c16.015625 0 29-12.984375 29-29v-62.199219zm0 0",
    fill: "url(#o)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m476.566406 167.71875c.445313-.820312.851563-1.667969 1.21875-2.535156.183594-.433594.359375-.871094.519532-1.316406.324218-.890626.609374-1.796876.847656-2.722657.238281-.929687.429687-1.871093.578125-2.832031.21875-1.441406.335937-2.914062.335937-4.417969v-80.4375l-38.046875-38.042969c-2.535156-3.339843-6.539062-5.503906-11.058593-5.503906h-95.78125c-7.675782 0-13.898438 6.222656-13.898438 13.894532v95.78125c0 4.519531 2.167969 8.519531 5.507812 11.058593l32.246094 32.25h92.03125c5.503906 0 10.652344-1.535156 15.035156-4.199219.796876-.484374 1.570313-1.003906 2.316407-1.5625.371093-.277343.734375-.566406 1.09375-.859374.714843-.59375 1.402343-1.21875 2.058593-1.871094 1.96875-1.96875 3.65625-4.21875 4.996094-6.683594zm0 0",
    fill: "url(#p)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m430.964844 153.484375h-95.785156c-7.671876 0-13.894532-6.222656-13.894532-13.894531v-95.785156c0-7.671876 6.222656-13.894532 13.894532-13.894532h95.785156c7.671875 0 13.894531 6.222656 13.894531 13.894532v95.785156c0 7.671875-6.222656 13.894531-13.894531 13.894531zm0 0",
    fill: "url(#q)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m44.058594 44.179688h181.101562v15.992187h-181.101562zm0 0",
    fill: "url(#s)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m44.058594 83.699219h181.101562v15.992187h-181.101562zm0 0",
    fill: "url(#t)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m44.058594 123.21875h144.210937v15.992188h-144.210937zm0 0",
    fill: "url(#u)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m430.964844 153.484375c7.671875 0 13.894531-6.222656 13.894531-13.894531v-81.648438l-43.429687 43.425782c-3.945313 3.953124-10.402344 3.953124-14.371094 0l-32.191406-32.195313c-5.855469-5.863281-15.355469-5.863281-21.210938 0-5.851562 5.859375-5.851562 15.355469 0 21.207031l63.105469 63.105469zm0 0",
    fill: "url(#v)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m507.605469 16.414062c5.859375 5.859376 5.859375 15.355469 0 21.210938l-84.960938 84.953125c-15.660156 15.660156-41.140625 15.660156-56.792969 0l-32.195312-32.199219c-5.855469-5.855468-5.855469-15.347656 0-21.207031s15.351562-5.859375 21.210938 0l32.191406 32.1875c3.960937 3.964844 10.417968 3.964844 14.371094 0l84.960937-84.949219c5.855469-5.859375 15.351563-5.855468 21.210937 0zm0 0",
    fill: "url(#w)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsability);
export default __webpack_public_path__ + "static/media/icon-usability.b445fd68c47294cd40a84cbe9e916cbd.svg";
export { ForwardRef as ReactComponent };